import { Chip } from "@mui/material"

export function TaskReadOnlyScheduleReferenceChip({ item }) {
    return <Chip size="small" variant="outlined" label={item.title ? `${item.code} - ${item.title}` : item.code} />
}
